import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import { BiCaretDown } from "react-icons/bi";
import "../navbar.css";

const PRODUCT_LINKS_COL1 = [
  { label: "Rodilleras", to: "/rodilleras" },
  { label: "Rodilleras Rígidas", to: "/rodilleras-rig" },
  { label: "Cinturones", to: "/cinturones" },
  { label: "Calzado", to: "/calzado" },
];

const PRODUCT_LINKS_COL2 = [
  { label: "Muñequeras", to: "/muñequeras" },
  { label: "Singlets", to: "/singlets" },
  { label: "Vendas", to: "/vendas" },
];

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [desktopProductsOpen, setDesktopProductsOpen] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);

  const productsRef = useRef(null);

  const closeAll = () => {
    setDrawerOpen(false);
    setDesktopProductsOpen(false);
    setMobileProductsOpen(false);
  };

  /* ---------- CLICK OUTSIDE (DESKTOP) ---------- */
  useEffect(() => {
    const handleClick = (e) => {
      if (
        productsRef.current &&
        !productsRef.current.contains(e.target)
      ) {
        setDesktopProductsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <>
      <nav>
        <div className="nav-inner">

          {/* MOBILE ICON */}
          <button
            className="nav-icon"
            onClick={() => setDrawerOpen(true)}
          >
            <FiMenu size={28} />
          </button>

          {/* LOGO */}
          <Link className="logo-container" to="/" onClick={closeAll}>
            <img alt="" src="/logos/ls-logo.png" className="ls-logo" />
{/*             <img alt="" src="/brazo-img.png" className="brazo-img" />
            <p className="name-ls">LIFTING STORE</p>
            <img alt="" className="arg-ban" src="/logos/arg-bandera.webp" /> */}
          </Link>

          {/* DESKTOP NAV */}
          <ul className="desktop-nav">
            <li>
              <Link to="/">Inicio</Link>
            </li>

            <li
              className="desktop-products"
              ref={productsRef}
              onMouseEnter={() => setDesktopProductsOpen(true)}
              onMouseLeave={() => setDesktopProductsOpen(false)}
            >
              <Link
                to="#"
                className="products-link"
                onClick={(e) => e.preventDefault()}
              >
                Productos
                <BiCaretDown
                  className={desktopProductsOpen ? "rotate" : ""}
                />
              </Link>

              <div
                className={`mega-menu ${
                  desktopProductsOpen ? "submenu--open" : ""
                }`}
              >
                <div className="mega-inner">
                  <div className="mega-col">
                    <p className="mega-title">Colecciones</p>
                    {PRODUCT_LINKS_COL1.map((item) => (
                      <Link
                        key={item.to}
                        to={item.to}
                        onClick={closeAll}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>

                  <div className="mega-col">
                    <p className="mega-title">Más</p>
                    {PRODUCT_LINKS_COL2.map((item) => (
                      <Link
                        key={item.to}
                        to={item.to}
                        onClick={closeAll}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </li>
            <li>
              <Link to="/comoencargar">¿Cómo hacer un encargo?</Link>
            </li>
            <li>
              <Link to="/politicas">Políticas</Link>
            </li>
          </ul>
        </div>
      </nav>

      {/* OVERLAY */}
      <div
        className={`overlay ${drawerOpen ? "overlay--show" : ""}`}
        onClick={closeAll}
      />

      {/* MOBILE DRAWER */}
      <div className={`drawer ${drawerOpen ? "drawer--open" : ""}`}>
        <div className="drawer-header">
          <span>Menú</span>
          <FiX size={22} onClick={closeAll} />
        </div>

        <Link
          to="/"
          onClick={closeAll}
          className="drawer-link"
        >
          Inicio
        </Link>

        <button
          className="drawer-link drawer-products"
          onClick={() =>
            setMobileProductsOpen((prev) => !prev)
          }
        >
          Productos
          <BiCaretDown
            className={mobileProductsOpen ? "rotate" : ""}
          />
        </button>

        <div
          className={`drawer-sub ${
            mobileProductsOpen ? "show" : ""
          }`}
        >
          {[...PRODUCT_LINKS_COL1, ...PRODUCT_LINKS_COL2].map(
            (item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={closeAll}
                className="drawer-sublink"
              >
                {item.label}
              </Link>
            )
          )}
        </div>
        <Link
          to="/comoencargar"
          onClick={closeAll}
          className="drawer-link"
        >
          ¿Cómo hacer un encargo?
        </Link>
        <Link
          to="/politicas"
          onClick={closeAll}
          className="drawer-link"
        >
          Políticas
        </Link>
        
      </div>
    </>
  );
};

export default Navbar;
  